import { render, staticRenderFns } from "./VorstossSignatory.vue?vue&type=template&id=87433f14"
import script from "./VorstossSignatory.vue?vue&type=script&lang=js"
export * from "./VorstossSignatory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports